import React, { Component } from 'react'

import BkFlowEnhancementsCardDefault from '../layouts/BkFlowEnhancementsCardDefault'
import BkFlowEnhancementsCardFull from '../layouts/BkFlowEnhancementsCardFull'

import yn from 'yn'
import _ from 'lodash'

import formatPrice from '../../../utilities/currency/formatPrice'

import placeholderImage from '../../../assets/images/placeholder-image.png'

class BkFlowEnhancementsCard extends Component {
  constructor(props) {
    super(props)

    this.state = {
      serviceDescriptionExpanded: false
    }
  }

  handleToggleServiceDescription = () => {
    this.setState({
      serviceDescriptionExpanded: !this.state.serviceDescriptionExpanded
    })
  }

  render() {
    const {
      activeCurrencyData,
      activeEnhancementData,
      activeRoom,
      configData,
      currencyCode,
      currencySymbol,
      enhancementCardType,
      enhancementKey,
      roomGroupKey,
    } = this.props

    const hotelLabels = configData.hotel.labels[0]
    const enhancementDetailsData = enhancementCardType[enhancementKey].serviceDetails.comments,
      currentEnhancementKey = enhancementCardType[enhancementKey].serviceInventoryCode + '-' + activeRoom[roomGroupKey][0][0].roomTypeCode + '-' + activeRoom[roomGroupKey][1][0].ratePlanCode + '-' + roomGroupKey

    // Loop and uniquely key enhancement details
    let keyedDetails = {}

    for (let detailKey in enhancementDetailsData) {
      keyedDetails[enhancementDetailsData[detailKey].name.toLowerCase()] = enhancementDetailsData[detailKey]
    }

    let isEnhancementSelected = false

    Object.keys(activeEnhancementData).filter(activeKey => {
      if (activeKey === currentEnhancementKey) {
        return isEnhancementSelected = true
      }

      return isEnhancementSelected
    })

    if (!_.isEmpty(keyedDetails)) {
      let enhancementImageSrc = placeholderImage,
        enhancementPrice = null

      if (
        keyedDetails.image &&
        keyedDetails.image.image
      ) {
        enhancementImageSrc = keyedDetails.image.image
      }

      // render price based on CRS value * exchange or CRS value
      if (
        yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
        activeCurrencyData &&
        activeCurrencyData.exchangeRate &&
        enhancementCardType[enhancementKey] &&
        _.get(enhancementCardType[enhancementKey].price, '[0].base.amountBeforeTax')
      ) {
        enhancementPrice = formatPrice(enhancementCardType[enhancementKey].price[0].base.amountBeforeTax * activeCurrencyData.exchangeRate, 2)
      } else if (
        enhancementCardType[enhancementKey] &&
        _.get(enhancementCardType[enhancementKey].price, '[0].base.amountBeforeTax')
      ) {
        enhancementPrice = formatPrice(enhancementCardType[enhancementKey].price[0].base.amountBeforeTax, 2)
      }

      return (
        process.env.REACT_APP_COMPONENT_ENHANCEMENTS_CARD_LAYOUT === 'full' ?
          <BkFlowEnhancementsCardFull
            activeRoom={activeRoom}
            currencySymbol={currencySymbol}
            currentEnhancementKey={currentEnhancementKey}
            enhancementCardType={enhancementCardType}
            enhancementImageSrc={enhancementImageSrc}
            enhancementKey={enhancementKey}
            enhancementPrice={enhancementPrice}
            handleToggleServiceDescription={() => this.handleToggleServiceDescription()}
            hotelLabels={hotelLabels}
            isEnhancementSelected={isEnhancementSelected}
            keyedDetails={keyedDetails}
            roomGroupKey={roomGroupKey}
            serviceDescriptionExpanded={this.state.serviceDescriptionExpanded}
          />
        :
          <BkFlowEnhancementsCardDefault
            activeRoom={activeRoom}
            currencyCode={currencyCode}
            currencySymbol={currencySymbol}
            currentEnhancementKey={currentEnhancementKey}
            enhancementCardType={enhancementCardType}
            enhancementImageSrc={enhancementImageSrc}
            enhancementKey={enhancementKey}
            enhancementPrice={enhancementPrice}
            handleToggleServiceDescription={() => this.handleToggleServiceDescription()}
            hotelLabels={hotelLabels}
            isEnhancementSelected={isEnhancementSelected}
            keyedDetails={keyedDetails}
            roomGroupKey={roomGroupKey}
            serviceDescriptionExpanded={this.state.serviceDescriptionExpanded}
          />
      )
    }
  }
}

export default BkFlowEnhancementsCard



// WEBPACK FOOTER //
// ./src/components/enhancements/elements/BkFlowEnhancementsCard.js